import React from 'react';

export default function ButtonLink({className, text, disabled, ...other}) {
	return <button className={`button button--link ${className ? className : ''}`} disabled={disabled} {...other}>
		{text}
	</button>
}
